// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "buyer-responsive-" + ({"1367": "ModelViewer","2257": "EthereumWallet","582": "NftSecondaryMarketModal","7530": "ActionToast","7581": "NftPdpZoomModal","8692": "RecentlyViewed",}[chunkId] || chunkId) + ".555.0.0." + {"1367": "88d8f70b29e4f885","2257": "d651c7ab62ef1ea9","2973": "31b6d94c87651279","582": "2878492819e768a2","7530": "44ee5b4e2b236a1b","7581": "b403d7a4dd36486d","8692": "5092936417bb63e3",}[chunkId] + ".css"
}